export default function OrderByAlfaNumeric(data: string[]){
    let values: string[] = [];

    data.map((value) => {        
        if(value && value.length > 0 && !values.includes(value.toUpperCase().substring(0, 1))) {
            values.push(value.toUpperCase().substring(0, 1));
        }
    })

    return values;
}